import React, { useState, useEffect } from "react";
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { PulseLoader } from "react-spinners";
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const StepThree = (props) => {
   const [timesLoading, setTimesLoading] = useState(props.availableTimes === 'waiting')
   var days = props.barberWorkingDays;
   console.log(props.barberWorkingDays)
   const today = dayjs();
   const todayString = today.$D + "-" + today.$M + "-" + today.$y
   useEffect(() => {
      window.scrollTo(0,0)
      if (props.defaultDate === undefined || props.defaultDate === null)
      {
         props.queryDate(dayjs().add(1, 'day'))
      }
      else
      {
      props.queryDate(props.defaultDate)
      }
	}, []);

   return (
   <div style={{marginTop:"2rem"}} className="booking-portal-step-wrapper">
      <h2 style={{marginBottom:0, marginLeft:"auto", marginRight:"auto"}} className="grid-title">Select a time</h2>
      <section>
         <Container>
            {days === null ?       
            
            <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
         <div style={{marginTop:"2rem"}}>        
            <PulseLoader 
            color={'#333'}
            loading={days === null}
            size={25}
            aria-label="Loading Spinner"
            data-testid="loader"
            />
         </div>
      </div> 
      
      :
            <Row>
               <Col className="" xxl={12}>
                                                <IconButton aria-label="delete" size="large">
                    <ArrowBackIcon className="back-arrow" onClick={() => {props.goTo(1); props.setAvailableTime('waiting')}} />
                  </IconButton>
               </Col>
               <Col className="mb-3" xxl={4} xl={4} lg={5} md={6} sm={12}>
                                                {/* <IconButton aria-label="delete" size="large">
                    <ArrowBackIcon onClick={() => {props.goTo(0); props.setBarberData("waiting")}} />
                  </IconButton> */}
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                     <StaticDatePicker
                     defaultValue={props.defaultDate === undefined ? dayjs().add(1, 'day'): props.defaultDate == null ? dayjs().add(1, 'day') : props.defaultDate}
                     disablePast
                     disableHighlightToday
                     maxDate={dayjs().add(2, 'months')}
                     componentsProps={{ actionBar: { actions: [ ] }, toolbar: {hidden: true} }}
                     onChange={(date) => {props.queryDate(date);}}
                     shouldDisableDate ={(date) => {
                        if (todayString === (date.$D + "-" + date.$M + "-" + date.$y))
                           {
                              return true
                           }
                        if ((days.filter(day => day -1 === date.day())).length > 0)
                           {
                              return false
                           } else {
                              return true
                           }
                        }}
                     />
                  </LocalizationProvider>
               </Col>
               <Col xxl={8} xl={8} lg={7} md={6} sm={12}>
                  <Row>

                        {props.availableTimes === 'waiting' ?
                        <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
                           <div className="test">        
                              <PulseLoader 
                              color={'#333'}
                              loading={props.availableTimes === 'waiting'}
                              size={12}
                              aria-label="Loading Spinner"
                              data-testid="loader"
                              />
                           </div>
                        </div>
                        :
                        props.availableTimes === null ? <div className="service-info"><p>No times</p></div> :
                        props.availableTimes.map((availableTime, index) => (
                           // <div className="time-card-grid">
                           //    <p className="grid-title-text">{availableTime.label}</p>
                           // </div>
                        <Col className="mb-3" key={index} lg={3} md={4} sm={3} xs={4}>

                           {/* <Card> */}
                              {/* <CardActionArea onClick={() => {props.goTo(3); props.selectTime(availableTime.label); props.selectTimeId(availableTime.value)}}> */}
                                 {/* <CardContent> */}
                                    <div style={{marginLeft:"auto", marginRight:"auto"}} className="time-card" onClick={() => {props.goTo(3); props.selectTime(availableTime.label); props.selectTimeId(availableTime.value)}}>
                                       {availableTime.label}
                                    </div>
                                 {/* </CardContent> */}
                              {/* </CardActionArea> */}
                           {/* </Card> */}
                        </Col>
                     ))}
                  </Row>
               </Col>
            </Row>
            }
         </Container>
      </section>


             {/* <div>
              <section>
                <div className="time-wrapper">
                  <h2 style={{marginBottom:0, marginLeft:"auto", marginRight:"auto"}} className="grid-title">Choose A Person</h2>
                  <IconButton aria-label="delete" size="large">
                    <ArrowBackIcon onClick={() => {props.goTo(0); props.setBarberData("waiting")}} />
                  </IconButton>
                  <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
                    <div style={{marginTop:"0"}}>
                      <PulseLoader 
                        color={'#333'}
                        loading={props.barbers == 'waiting'}
                        size={25}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    </div>
                  </div>
                  <div className="time-grid">
                    {props.barbers == 'waiting' ? <></>
                    :
                   props.barbers == null ? <div>No barbers</div>:
                   <div>
             <div className="time-grid">
               {props.barbers.map((barber, index) => (
                 <div onClick={() => {props.handleBarberSelected(barber); props.goTo(2); props.getBarberWorkingDays(barber.barberId);}} className="service-card-grid" key={index}>
                   <img
                     src={process.env.REACT_APP_API_SERVICE_BASE_URL+'image/' + "BarberProfileImages/" + barber.filename}
                     className="grid-image"
                   />
                   <p className="grid-title-text">{barber.name}</p>
                 </div>
               ))}
             </div>
                  </div>     
              }
              </div>
              </div>
            </section>
          </div> */}
      </div>
      
   );
};

export default StepThree;
